import styled from 'styled-components';

import {
	GhostButton,
} from 'lib/styles';

const Container = styled.div`
	display: flex;
	position: fixed;
	top: 0;
	left: 2vw;
	width: 96vw;
	height: 98vh;
	background-color: rgba(242, 242, 242, 0.98);
	z-index: 9;
	padding: 80px 20px 0;
	justify-content: space-between;
	justify-items: flex-end;
	border-radius: 0 0 8px 8px;
	box-shadow: 0px 8px 60px -32px rgba(0,0,0,0.7);
	transform: translateY(${props => props.open ? '0vh' : '-100vh'});
	transition: all 0.3s ease-out;
	will-change: transform;
	pointer-events: ${props => props.open ? 'default' : 'none'};

	&:before {
		content: "";
		position: fixed;
		top: 0;
		left: -4vw;
		width: 100vw;
		height: 100vh;
	}
`;

const CloseButton = styled(GhostButton)`
	position: absolute;
	top: 16px;
	right: 40px;
	color: black;
`;

export {
	Container,
	CloseButton,
}
